import React, { useContext, useState } from 'react'
import { useParams, useSearchParams } from "react-router-dom"
import { programmeContext, programmeNameContext, languageContext, state } from '../../../contexts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'

import Pano from "./Pano"
import Pano3D from "./Pano3D"

import { useEffect } from 'react';


const PanoContent = ({vimCurrentFloor, setVimCurrentFloor, fromPano}) => {

    const {currentInt} = useParams()
    const programmeName = useContext(programmeNameContext)
    const [searchParams, setSearchParams] = useSearchParams()
    const lang = useContext(languageContext)
    const programmeDatas = useContext(programmeContext)
    const interieursDatas = programmeDatas.pagesDetails.interieurs2
    const currentLotDatas = interieursDatas.pano.find(x => x.texts[lang] == currentInt)
    
    const getRoom = (list, value) => {
        const currentRoom = list.find(room => room.title[lang] === value) || list[0]
        return currentRoom
    }

    const room = getRoom(currentLotDatas.pieces, searchParams.get('piece'))
    const [miniMapStyle, setMiniMapStyle] = useState('normal')
    const miniMapSize = miniMapStyle === 'normal' ? 320 : document.body.clientHeight
    const [direction, setDirection] = useState(0)
    const [initialDir, setInitialDir] = useState(1000)
    const vimFloorCount = [... new Set(currentLotDatas.pieces.map(p => p.views.map(v => v.floor)).flat())]
    const [varianteId, setVariantId] = useState("")

    const [pano, setPano] = useState(null)

    useEffect(() => {
        if (searchParams.get("decoration")) {
            const good = currentLotDatas.variantes["Décoration"].filter(p => p.name[lang] === searchParams.get("decoration"))
            if (good[0]) {
                setVariantId(`-${good[0].id}`)
            }
        }

        if (searchParams.get("prestation")) {
            const good = currentLotDatas.variantes["Préstation"].filter(p => p.name[lang] === searchParams.get("prestation"))
            if (good[0]) {
                setVariantId(`-${good[0].id}`)
            }
        }

    }, [currentInt, room, searchParams.get("decoration"), searchParams.get("prestation")])

    useEffect(() => {
        setVimCurrentFloor(0)
    }, [currentInt])

    useEffect(() => {

        if (interieursDatas.vimType !== "Navigation 3D") {

            document.addEventListener('click', e => {

                const x = e.x
                const y = e.y
                const width = document.body.clientWidth
                const height = document.body.clientHeight

                if (height > 599) {
                    if (miniMapStyle === "normal") {
                        if (width - x > 40 && width - x < 360 && y > 10 && y < 330) {
                            setMiniMapStyle('full')
                        }
                    } else {
                        if (x > (width - height) / 2 && x < width  - ((width - height) / 2)) {
                            setMiniMapStyle('normal')
                        }
                    }
                }
                else {
                    if (miniMapStyle === "normal") {
                        if (width - x > 29 && width - x < 172 && y > 28 && y < 172) {
                            setMiniMapStyle('full')
                        }
                    } else {
                        if (x > (width - height) / 2 && x < width  - ((width - height) / 2)) {
                            setMiniMapStyle('normal')
                        }
                    }
                }

                
            })

            //
            document.addEventListener('touchend', e => {

                const x = e.x
                const y = e.y
                const width = document.body.clientWidth
                const height = document.body.clientHeight

                if (height > 599) {
                    if (miniMapStyle === "normal") {
                        if (width - x > 40 && width - x < 360 && y > 10 && y < 330) {
                            setMiniMapStyle('full')
                        }
                    } else {
                        if (x > (width - height) / 2 && x < width  - ((width - height) / 2)) {
                            setMiniMapStyle('normal')
                        }
                    }
                }
                else {
                    if (miniMapStyle === "normal") {
                        if (width - x > 29 && width - x < 172 && y > 28 && y < 172) {
                            setMiniMapStyle('full')
                        }
                    } else {
                        if (x > (width - height) / 2 && x < width  - ((width - height) / 2)) {
                            setMiniMapStyle('normal')
                        }
                    }
                }

                
            })
        }

    }, [miniMapStyle])

    useEffect(() => {
        if (room) {
            setVimCurrentFloor(room.views[0].floor)
        }
    }, [room])

    useEffect(() => {
        setPano(false) 

        setTimeout(() => {
            setPano(true)
        }, 100)
    }, [currentInt])


    const setMiniMapSize = () => {

        setMiniMapStyle(old => {
            if (old === "normal") {
                return 'full'
            } else {
                return "normal"
            }
        })
    }

    if (!room) {return}


    return (
        <>
            {pano && <>
                {interieursDatas.vimType !== "Navigation 3D" ?
                    <Pano
                        currentInt={currentInt}
                        view={room}
                        decoration = {searchParams.get("decoration")}
                        prestation={searchParams.get("prestation")}
                        setDirection = {setDirection}
                        initialDir = {initialDir}
                        setInitialDir = {setInitialDir}
                        setVimCurrentFloor = {setVimCurrentFloor}
                    />
                : 
                    <Pano3D
                        currentInt={currentInt}
                        room={room}
                        setVimCurrentFloor = {setVimCurrentFloor}
                        setDirection = {setDirection}
                        fromPano = {fromPano}
                    />
                } 
                </>
            }

            {(currentLotDatas.miniMapPois.length && !currentLotDatas.hideMinimap) &&
                <div id = "panoMiniMap" className = {miniMapStyle} onClick = {e => {if (interieursDatas.vimType === "Navigation 3D") {e.stopPropagation() ; setMiniMapSize()} else {}}}>
                                        
                    <img src = {`${state === "local" ? "http://moteur-v6" : ""}/public/programmes/${programmeName}/interieurs2/${currentLotDatas.id}/minimap${vimCurrentFloor ? vimCurrentFloor : ""}${varianteId || '-main'}.png`}></img>

                    <div id = "panoMiniMapPalette">

                        {vimFloorCount.length > 1 && vimFloorCount.sort().map(f => <button className = {vimCurrentFloor === f ? "mainBackground" : ""} onClick = {e => {e.stopPropagation() ; setVimCurrentFloor(f)}}>Niveau {f}</button>)}

                    </div>

                    {currentLotDatas.miniMapPois.filter(x => x.floor === vimCurrentFloor).map(piece => 
                        
                        <div 
                            className = {`minimapButton ${currentLotDatas.pieces[room.order].views[0].id === parseInt(piece.link.split('-')[1]) ? "activRoom" : ""}`}
                            onClick = {e => {
                                e.stopPropagation()

                                fromPano.current = false
                                const goodOne = currentLotDatas.pieces.filter(x => x.id === parseInt(piece.link.split('-')[0]))

                                if (goodOne[0]) {
                                    searchParams.set("piece", goodOne[0].title[lang])
                                    setSearchParams(searchParams)
                                    setMiniMapStyle("normal")
                                }

                            }}
                            style = {{left : `${miniMapSize*piece.x/100}px`, top : `${miniMapSize*piece.y/100}px`}}
                        >
                            { currentLotDatas.pieces[room.order].views[0].id === parseInt(piece.link.split('-')[1]) && 
                                <div className = "visioCone" style = {{rotate : `${piece.offset - (interieursDatas.vimType !== "Navigation 3D" ? initialDir : 0) + direction}deg`}}>
                                    <svg 
                                        width = "82" 
                                        height = "82" 
                                        style = {{position: 'absolute', left: '-16px', top: '-16px', pointerEvents : "none"}}
                                    >
                                            <path 
                                                stroke = {programmeDatas.color}
                                                strokeWidth = "1" 
                                                strokeOpacity = "0.45" 
                                                fill = {programmeDatas.color} 
                                                fillOpacity = "0.45" 
                                                d = "M 40.5,40.5 L 26.894271311943584,77.04974893028677 A 39,39 0 0 1 15.649853268456681,10.442218854001098 Z" 
                                                style = {{cursor: 'pointer', transform: 'scale(1, 1)', pointerEvents : "none"}}
                                            ></path>
                                    </svg>
                                </div>
                            } 
                            <FontAwesomeIcon icon = {faEye}/>
                        </div>

                    )}             
                </div>
            }
        </>
    )
}


export default PanoContent